<template>
  <v-layout wrap justify-end>
    <v-flex xs12>
      <div class="dpr-table-region" role="region" :aria-label="tableRegionLabel">
      <v-data-table
        v-if="results.scope=='park'"
        :headers="parkHeaders"
        :items="results.list"
        :pagination.sync="pagination"
      >
        <template v-slot:items="{ item }">
          <td>{{ item.facilityName }}</td>
          <td>{{ item.reservationPurposeDsc }}</td>
          <td>{{ item.customerName }}</td>
          <td>{{ formatDate(item.reservationBeginDtm) }}</td>
          <td>{{ formatTime(item.reservationBeginDtm) }}</td>
          <td>{{ formatTime(item.reservationEndDtm) }}</td>
        </template>
      </v-data-table>
      <v-data-table
        v-else
        :headers="fieldHeaders"
        :items="results.list"
        :pagination.sync="pagination"
      >
        <template v-slot:items="{ item }">
          <td>{{ item.reservationPurposeDsc }}</td>
          <td>{{ item.customerName }}</td>
          <td>{{ formatDate(item.reservationBeginDtm) }}</td>
          <td>{{ formatTime(item.reservationBeginDtm) }}</td>
          <td>{{ formatTime(item.reservationEndDtm) }}</td>
        </template>
      </v-data-table>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
  import moment from 'moment'

  export default {
    props: ['results'],
    computed: {
      tableRegionLabel () {
        if (!this.results || this.results.scope === 'park') {
          return 'Reservation list including field, purpose, reservee, date, and times'
        }
        return 'Reservation list including purpose, reservee, date, and times'
      }
    },
    data: () => ({
      fieldHeaders: [
        { text: 'Purpose', value: 'reservationPurposeDsc' },
        { text: 'Reservee', value: 'customerName' },
        { text: 'Date', value: 'reservationBeginDtm' },
        { text: 'Start', sortable: false },
        { text: 'End', sortable: false }
      ],
      parkHeaders: [
        { text: 'Field', value: 'facilityName' },
        { text: 'Purpose', value: 'reservationPurposeDsc' },
        { text: 'Reservee', value: 'customerName' },
        { text: 'Date', value: 'reservationBeginDtm' },
        { text: 'Start', sortable: false },
        { text: 'End', sortable: false }
      ],
      pagination: {
        sortBy: 'reservationBeginDtm'
      }
    }),
    methods: {
      formatDate(date){ return moment(date).format('MM/DD/YYYY') },
      formatTime(time){ return moment(time).format('h:mma') }
    }
  }
</script>